var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons2ExportEvents44(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 9H34V11H37C38.7 11 40 12.3 40 14V17H42V14C42 11.2 39.8 9 37 9Z",
    fill: "#4E4B45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 9H16V11H32V9Z",
    fill: "#4E4B45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37C40 38.7 38.7 40 37 40H11C9.3 40 8 38.7 8 37V19V17V14C8 12.3 9.3 11 11 11H14V9H11C8.2 9 6 11.2 6 14V37C6 39.8 8.2 42 11 42H37C39.8 42 42 39.8 42 37V19H40V37Z",
    fill: "#4E4B45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17V19H40H42V17H40H8Z",
    fill: "#4E4B45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H16V11V9V6H14V9V11V13Z",
    fill: "#4E4B45"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 13H34V11V9V6H32V9V11V13Z",
    fill: "#4E4B45"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 31L19.4 35.4C19.4 35.7 19.5 36 19.7 36.1C19.9 36.3 20.2 36.3 20.5 36.2L24.5 34.1L28.5 36.2C28.6 36.3 28.7 36.3 28.8 36.3C29 36.3 29.1 36.3 29.2 36.2C29.4 36 29.5 35.7 29.5 35.5L28.8 31L32 27.9C32.2 27.7 32.3 27.4 32.2 27.1C32.1 26.8 31.9 26.6 31.6 26.6L27.1 26L25.1 22C24.8 21.5 24 21.5 23.8 22L21.8 26L17.3 26.6C17 26.6 16.8 26.8 16.7 27.1C16.6 27.4 16.7 27.7 16.9 27.9L20.2 31ZM22.4 27.3C22.6 27.3 22.9 27.1 23 26.9L24.5 23.9L26 26.9C26.1 27.1 26.3 27.3 26.6 27.3L29.9 27.8L27.5 30.2C27.3 30.4 27.2 30.6 27.3 30.9L27.9 34.2L24.9 32.6C24.8 32.5 24.7 32.5 24.6 32.5C24.5 32.5 24.4 32.5 24.3 32.6L21.3 34.2L21.9 30.9C21.9 30.7 21.9 30.4 21.7 30.2L19.3 27.8L22.4 27.3Z",
    fill: "#4E4B45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons2ExportEvents44);
export default __webpack_public_path__ + "static/media/icons-2_export-EVENTS-44.c21cc0475877170001cf85d8a83405ef.svg";
export { ForwardRef as ReactComponent };